import { TraderInfoAction } from './trader.action';

export interface TraderInfoState {
        userId: number,
        isTrader: boolean,
        profileInfo: {
            typeProfile: string
        },
        contractLastMonth: number,
        contractCurrentMonth: number,
        platforms: any[],
        clubTrader: {
            starter: {
                minimum: number,
                maximum: number
            },
            master: {
                minimum: number,
                maximum: number
            },
            vip: {
                minimum: number
            }
        },
        pending: boolean;
        error: null;
}

export const initialState: TraderInfoState = {
    userId: 0,
    isTrader: false,
    profileInfo: {
        typeProfile: "DEFAULT"
    },
    contractLastMonth: 0,
    contractCurrentMonth: 0,
    platforms: [],
    clubTrader: {
        starter: {
            minimum: 20,
            maximum: 499
        },
        master: {
            minimum: 500,
            maximum: 999
        },
        vip: {
            minimum: 1000
        }
    },
    pending: true,
    error: null,
};

export function TraderInfoReducer(state: TraderInfoState = initialState, action: TraderInfoAction) {
    switch (action.type) {
        case TraderInfoAction.traderInfo:
            return {...state, ...{ pending: true, error: null } };
        case TraderInfoAction.traderInfoSuccess:
            return {...state, ...action.payload, ...{ pending: false, error: null }};
        case TraderInfoAction.traderInfoError:
            return {...state, ...{ pending: false, error: true } };
        default:
            return state;
    }
}